__turbopack_context__.v({
  "timelineBase": "PhaseTimeline-module-scss-module__WFRKGW__timelineBase",
  "timelineBaseHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineBaseHoriz",
  "timelineCaret": "PhaseTimeline-module-scss-module__WFRKGW__timelineCaret",
  "timelineCaretHit": "PhaseTimeline-module-scss-module__WFRKGW__timelineCaretHit",
  "timelineCaretHitHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineCaretHitHoriz",
  "timelineCaretHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineCaretHoriz",
  "timelineEvt": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvt",
  "timelineEvtEnd": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvtEnd",
  "timelineEvtEndHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvtEndHoriz",
  "timelineEvtHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvtHoriz",
  "timelineEvtStart": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvtStart",
  "timelineEvtStartHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineEvtStartHoriz",
  "timelineLine": "PhaseTimeline-module-scss-module__WFRKGW__timelineLine",
  "timelineLineHoriz": "PhaseTimeline-module-scss-module__WFRKGW__timelineLineHoriz",
});
